// extracted by mini-css-extract-plugin
export var callCard = "_jl-0";
export var callMessageButton = "_jl-1";
export var helpIcon = "_jl-3";
export var helpIconContainer = "_jl-4";
export var verticalDivider = "_jl-2";